import React, { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import useResizeObserver from 'Hooks/useResizeObserver'
import styled from '@emotion/styled'

import {
  Loading,
  SpacingVertical,
  SPACING_24,
  Flex
} from 'mailup-web-components'
import ErrorFeedback from 'Components/ErrorFeedback'
import Descriptions from './components/Descriptions'
import Input from './components/Input/Input'
import Footer from './components/Footer'

import { cleanupCallback, initCallback } from './recoil/callbacks/callbacks'
import { pageState } from './recoil/state/page'
import PageContainer from 'Components/PageContainer'
import { notifyParent } from 'mailup-react-helpers'

const UrlSelection = () => {
  const { loaded, loading, error, severity } = useRecoilValue(pageState)
  const init = useRecoilCallback(initCallback, [])
  const cleanup = useRecoilCallback(cleanupCallback, [])

  useEffect(() => {
    init()
    notifyParent('pageResize', [])
    return () => {
      cleanup()
    }
  }, [])

  const notifyResize = payload => {
    notifyParent('pageResize', [payload])
  }
  useResizeObserver(document.querySelector('body'), notifyResize)

  return (
    <StyledPageContainer>
      <Flex display='block'>
        <Loading open={loading} />
        <>
          <ErrorFeedback
            error={error}
            severity={severity}
            onClickReload={init}
          />
          {loaded && !error && (
            <>
              <Descriptions />
              <Input />
              <SpacingVertical variant={SPACING_24} />
              <Footer />
            </>
          )}
        </>
      </Flex>
    </StyledPageContainer>
  )
}

export default UrlSelection

const StyledPageContainer = styled(PageContainer)`
  padding: 0;
  background-color: var(--pure-white);
  position: relative;
  top: -8px;
`
